import { MystudioApiError, getMystudioErrorMessage } from "../Common/api/v4";
import "./MystudioDataState.css";

const COPY = {
  loading: {
    title: "정보를 불러오고 있어요",
    description: "잠시만 기다려 주세요.",
  },
  empty: {
    title: "표시할 정보가 없어요",
    description: "스튜디오에 정보가 등록되면 이곳에서 확인할 수 있어요.",
  },
  error: {
    title: "정보를 불러오지 못했어요",
    description: "네트워크 연결을 확인한 뒤 다시 시도해 주세요.",
  },
};

/**
 * @param {{
 *   type?: "loading" | "empty" | "error";
 *   title?: string;
 *   description?: string;
 *   error?: unknown;
 *   onRetry?: (() => void) | null;
 *   compact?: boolean;
 *   className?: string;
 * }} props
 */
export default function MystudioDataState({
  type = "empty",
  title = "",
  description = "",
  error = null,
  onRetry = null,
  compact = false,
  className = "",
}) {
  const resolvedType = COPY[type] ? type : "empty";
  const copy = COPY[resolvedType];
  const isAuthenticationError = error instanceof MystudioApiError
    && error.kind === "authentication";
  const resolvedTitle = title
    || (isAuthenticationError ? "로그인이 필요해요" : copy.title);
  const resolvedDescription = description
    || (error ? getMystudioErrorMessage(error) : copy.description);
  const classes = [
    "mystudio-data-state",
    `is-${resolvedType}`,
    compact ? "is-compact" : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <div
      className={classes}
      role={resolvedType === "error" ? "alert" : "status"}
      aria-live={resolvedType === "loading" ? "polite" : undefined}
      aria-busy={resolvedType === "loading" ? "true" : undefined}
    >
      {resolvedType === "loading" ? <span className="mystudio-data-state__spinner" aria-hidden="true" /> : null}
      <strong>{resolvedTitle}</strong>
      {resolvedDescription ? <span>{resolvedDescription}</span> : null}
      {resolvedType === "error" && typeof onRetry === "function" && !isAuthenticationError ? (
        <button type="button" onClick={onRetry}>다시 시도</button>
      ) : null}
    </div>
  );
}
